

















































import Vue from "vue";
import Component from "vue-class-component";
import fieldData, { IReportingPeriod } from "@/ts/FormData";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";

@Component({
    props: {
        periodType: {
            type: String
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class ReportingPeriod extends Vue {
    name: string = "reporting-period";

    year: number | null = null;
    years: number[] = [];
    reportingPeriod: string | null = null;
    reportingPeriods: IReportingPeriod[] = [];
    errorMsgs = ErrorMessages;

    created(): void {
        this.years = fieldData.reportingPeriods.getYears();
        if (this.$attrs.reportingPeriod != null) {
            this.year = this.$attrs.reportingYear as unknown as number;
        } else if (this.$attrs.reportingYear != null) {
            this.year = this.$attrs.reportingYear as unknown as number;;
        } else {
            this.year = null;
        }
        this.updateRange();
        if (this.year != null) {
            this.reportingPeriod = this.$attrs.reportingPeriod;//this.reportingPeriods[0].name;
        }
     }

    mounted(): void {
        this.$watch("reportingPeriod", (n, o) => {
            this.$emit("update:reportingPeriod", this.reportingPeriod);
        }, { immediate: !this.$props.isReadOnly });

        this.$watch("year", (n, o) => {
            this.$emit("update:reportingYear", this.year);
        }, { immediate: !this.$props.isReadOnly });

        this.$watch("hasErrors", (n, o) => {
            this.$emit("update:hasErrors", this.hasErrors);
        }, { immediate: !this.$props.isReadOnly });
    }

    updateRange(): void {
        if (this.year != null) {
            if (this.$props.periodType === "quarterly") {
                this.reportingPeriods = fieldData.reportingPeriods.getQuarterly(this.year as unknown as number);
                this.reportingPeriod = this.$attrs.reportingPeriod;
            }

            if (this.$props.periodType === "biannual") {
                this.reportingPeriods = fieldData.reportingPeriods.getBiAnnual(this.year as unknown as number);
                this.reportingPeriod = this.$attrs.reportingPeriod;
            }

            if (this.$props.periodType === "yearly") {
                this.reportingPeriods = [];
                this.reportingPeriod = null;
            }
        }
    }

    get isYearsError(): boolean {
        return this.year === NaN; //|| !this.years.some(yr => yr === this.year as unknown as number);
    }

    get isReportingPeriodError(): boolean {
        if (this.reportingPeriod == null) {
            return true;
        } else {
            return false;
        }
        /* else {
            return !this.reportingPeriods.some(rp => rp.value.getTime() === this.reportingPeriod!.getTime());
        }
        */
    }

    get hasErrors(): boolean {
        return this.isYearsError || this.isReportingPeriodError;
    }
}

